export enum DownloadTargetEnum {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
